const PHONE_TOOL_URL = "https://phonetool.amazon.com/users/";

export const linkPhoneTool = (user: string) => (
  <a href={PHONE_TOOL_URL + encodeURIComponent(user)} target={"_blank"} rel="noreferrer">
    {user}
  </a>
);
